import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface TextAreaProps {
    class?: string;
    label?: string;
    id?: string;
    value: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    rows?: number;
    maxLength?: number;
}

export const TextArea = (props: TextAreaProps): JSX.Element => (
    <div class="mb-4 last:mb-0">
        {props.label && (
            <label for={props.id} class="k-body-bold block mb-2 font-semibold">
                {props.label}
            </label>
        )}
        <textarea
            class={classNames(
                'form-control block w-full py-3 transition duration-75 rounded-lg outline-none focus:border-primary-500 focus:ring-1 focus:ring-inset focus:ring-primary-500 disabled:opacity-70 border-gray-300',
                props.class
            )}
            id={props.id}
            value={props.value}
            onInput={(event): void => props.onChange?.(event.currentTarget.value)}
            placeholder={props.placeholder}
            required={props.required}
            disabled={props.disabled}
            rows={props.rows}
            maxLength={props.maxLength}
        />
    </div>
);
